export const DataMenu = [
    {
        "children": [],
        "key": "99922CA8-79A3-45F5-A2BF-3404C171D450",
        "parentkey": null,
        "id": "99922ca8-79a3-45f5-a2bf-3404c171d450",
        "menuId": "99922ca8-79a3-45f5-a2bf-3404c171d450",
        "parentId": null,
        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
        "isNavHeader": null,
        "classs": "navigation-header",
        "badge": null,
        "label": "Tổng quan",
        "icon": "asset asset-tong-quan",
        "intPos": 1,
        "childCount": 0,
        "isAction": false,
        "expanded": true,
        "actionCd": "",
        "actionType": "",
        "routerLink": "home",
        "workCount": null
    },
    {
        "children": [
            {
                "children": [
                    {
                        "children": [],
                        "key": "483F99F4-58F2-4D72-B165-5D10AA305D19",
                        "parentkey": null,
                        "id": "483f99f4-58f2-4d72-b165-5d10aa305d19",
                        "menuId": "c8aea697-a95e-44a7-b04a-cf12bd38d206",
                        "parentId": "c8aea697-a95e-44a7-b04a-cf12bd38d206",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Tìm Kiếm",
                        "icon": "uni-icon uni-send",
                        "intPos": 1,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "TIM_KIEM",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "5D5FEEFC-AB04-4D6C-9E5D-AFDB10951E28",
                        "parentkey": null,
                        "id": "5d5feefc-ab04-4d6c-9e5d-afdb10951e28",
                        "menuId": "c8aea697-a95e-44a7-b04a-cf12bd38d206",
                        "parentId": "c8aea697-a95e-44a7-b04a-cf12bd38d206",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Xóa",
                        "icon": "uni-icon uni-send",
                        "intPos": 1,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "XOA",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "D736A821-BFBC-49A9-9F7D-DC4B1BCE327A",
                        "parentkey": null,
                        "id": "d736a821-bfbc-49a9-9f7d-dc4b1bce327a",
                        "menuId": "c8aea697-a95e-44a7-b04a-cf12bd38d206",
                        "parentId": "c8aea697-a95e-44a7-b04a-cf12bd38d206",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Tùy Chỉnh",
                        "icon": "uni-icon uni-send",
                        "intPos": 1,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "TUY_CHINH",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "06581E29-65F2-49C7-8544-68C83567E932",
                        "parentkey": null,
                        "id": "06581e29-65f2-49c7-8544-68c83567e932",
                        "menuId": "c8aea697-a95e-44a7-b04a-cf12bd38d206",
                        "parentId": "c8aea697-a95e-44a7-b04a-cf12bd38d206",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Thêm mới",
                        "icon": "uni-icon uni-send",
                        "intPos": 1,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "THEM_MOI",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "0C2BFD39-F8CF-40E7-8D95-DB7DAEACD3BA",
                        "parentkey": null,
                        "id": "0c2bfd39-f8cf-40e7-8d95-db7daeacd3ba",
                        "menuId": "c8aea697-a95e-44a7-b04a-cf12bd38d206",
                        "parentId": "c8aea697-a95e-44a7-b04a-cf12bd38d206",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Tiện Ích",
                        "icon": "uni-icon uni-send",
                        "intPos": 2,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "TIEN_ICH",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "1C6B32BC-DE06-427C-A191-0CECDBC9170E",
                        "parentkey": null,
                        "id": "1c6b32bc-de06-427c-a191-0cecdbc9170e",
                        "menuId": "c8aea697-a95e-44a7-b04a-cf12bd38d206",
                        "parentId": "c8aea697-a95e-44a7-b04a-cf12bd38d206",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Sửa",
                        "icon": "uni-icon uni-send",
                        "intPos": 2,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "SUA",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    }
                ],
                "key": "C8AEA697-A95E-44A7-B04A-CF12BD38D206",
                "parentkey": null,
                "id": "c8aea697-a95e-44a7-b04a-cf12bd38d206",
                "menuId": "c8aea697-a95e-44a7-b04a-cf12bd38d206",
                "parentId": "c18fdc70-90df-47e2-b490-d949d8e65a0e",
                "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                "isNavHeader": null,
                "classs": "nav-item",
                "badge": null,
                "label": "Nhóm tài sản",
                "icon": null,
                "intPos": 1,
                "childCount": 0,
                "isAction": false,
                "expanded": true,
                "actionCd": "",
                "actionType": "",
                "routerLink": "/danh-muc/nhom-tai-san",
                "workCount": null
            },
            {
                "children": [
                    {
                        "children": [],
                        "key": "9A432D0C-C532-4F5D-9691-260BDFF97E5D",
                        "parentkey": null,
                        "id": "9a432d0c-c532-4f5d-9691-260bdff97e5d",
                        "menuId": "090fad1c-952e-4218-8f51-ba76ddb37d73",
                        "parentId": "090fad1c-952e-4218-8f51-ba76ddb37d73",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Tùy Chỉnh",
                        "icon": "uni-icon uni-send",
                        "intPos": 1,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "TUY_CHINH",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "EEA4CE63-07A5-41A0-8757-AA50FA661E94",
                        "parentkey": null,
                        "id": "eea4ce63-07a5-41a0-8757-aa50fa661e94",
                        "menuId": "090fad1c-952e-4218-8f51-ba76ddb37d73",
                        "parentId": "090fad1c-952e-4218-8f51-ba76ddb37d73",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Xóa",
                        "icon": "uni-icon uni-send",
                        "intPos": 1,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "XOA",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "816DF3FB-96F4-4194-8494-7CD7D470B9F3",
                        "parentkey": null,
                        "id": "816df3fb-96f4-4194-8494-7cd7d470b9f3",
                        "menuId": "090fad1c-952e-4218-8f51-ba76ddb37d73",
                        "parentId": "090fad1c-952e-4218-8f51-ba76ddb37d73",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Sửa",
                        "icon": "uni-icon uni-send",
                        "intPos": 2,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "SUA",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "542F0F75-1BE1-445C-A0C7-DE62D58C8C47",
                        "parentkey": null,
                        "id": "542f0f75-1be1-445c-a0c7-de62d58c8c47",
                        "menuId": "090fad1c-952e-4218-8f51-ba76ddb37d73",
                        "parentId": "090fad1c-952e-4218-8f51-ba76ddb37d73",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Tìm Kiếm",
                        "icon": "uni-icon uni-send",
                        "intPos": 3,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "TIM_KIEM",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "FA5477BC-9A43-41C0-9AE7-94BADB078977",
                        "parentkey": null,
                        "id": "fa5477bc-9a43-41c0-9ae7-94badb078977",
                        "menuId": "090fad1c-952e-4218-8f51-ba76ddb37d73",
                        "parentId": "090fad1c-952e-4218-8f51-ba76ddb37d73",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Tiện Ích",
                        "icon": "uni-icon uni-send",
                        "intPos": 4,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "TIEN_ICH",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "78E4CCB4-B67E-4206-8822-403E4B2B5BBD",
                        "parentkey": null,
                        "id": "78e4ccb4-b67e-4206-8822-403e4b2b5bbd",
                        "menuId": "090fad1c-952e-4218-8f51-ba76ddb37d73",
                        "parentId": "090fad1c-952e-4218-8f51-ba76ddb37d73",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Thêm mới",
                        "icon": "uni-icon uni-send",
                        "intPos": 5,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "THEM_MOI",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    }
                ],
                "key": "090FAD1C-952E-4218-8F51-BA76DDB37D73",
                "parentkey": null,
                "id": "090fad1c-952e-4218-8f51-ba76ddb37d73",
                "menuId": "090fad1c-952e-4218-8f51-ba76ddb37d73",
                "parentId": "c18fdc70-90df-47e2-b490-d949d8e65a0e",
                "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                "isNavHeader": null,
                "classs": "nav-item",
                "badge": null,
                "label": "Nhà cung cấp",
                "icon": "pi pi-shopping-bag",
                "intPos": 3,
                "childCount": 0,
                "isAction": false,
                "expanded": true,
                "actionCd": "",
                "actionType": "",
                "routerLink": "/danh-muc/nha-cung-cap",
                "workCount": null
            },
            {
                "children": [
                    {
                        "children": [],
                        "key": "93BD9242-EF47-4781-8B92-9DD8F5714EE6",
                        "parentkey": null,
                        "id": "93bd9242-ef47-4781-8b92-9dd8f5714ee6",
                        "menuId": "f044f3c0-6cbd-4407-bbab-b630d1fa2455",
                        "parentId": "f044f3c0-6cbd-4407-bbab-b630d1fa2455",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Xóa",
                        "icon": "uni-icon uni-send",
                        "intPos": 1,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "XOA",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "F2D379BC-7BF6-4834-9611-69E5C9D06F95",
                        "parentkey": null,
                        "id": "f2d379bc-7bf6-4834-9611-69e5c9d06f95",
                        "menuId": "f044f3c0-6cbd-4407-bbab-b630d1fa2455",
                        "parentId": "f044f3c0-6cbd-4407-bbab-b630d1fa2455",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Sửa",
                        "icon": "uni-icon uni-send",
                        "intPos": 2,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "SUA",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "64C3ADC2-A64B-4352-AA03-2D43C60F445C",
                        "parentkey": null,
                        "id": "64c3adc2-a64b-4352-aa03-2d43c60f445c",
                        "menuId": "f044f3c0-6cbd-4407-bbab-b630d1fa2455",
                        "parentId": "f044f3c0-6cbd-4407-bbab-b630d1fa2455",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Tìm Kiếm",
                        "icon": "uni-icon uni-send",
                        "intPos": 3,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "TIM_KIEM",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "27085AA3-DABB-4139-BDCB-058FB1BBBD30",
                        "parentkey": null,
                        "id": "27085aa3-dabb-4139-bdcb-058fb1bbbd30",
                        "menuId": "f044f3c0-6cbd-4407-bbab-b630d1fa2455",
                        "parentId": "f044f3c0-6cbd-4407-bbab-b630d1fa2455",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Tùy Chỉnh",
                        "icon": "uni-icon uni-send",
                        "intPos": 4,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "TUY_CHINH",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "3110215C-3602-49BC-A6B8-12FA27022815",
                        "parentkey": null,
                        "id": "3110215c-3602-49bc-a6b8-12fa27022815",
                        "menuId": "f044f3c0-6cbd-4407-bbab-b630d1fa2455",
                        "parentId": "f044f3c0-6cbd-4407-bbab-b630d1fa2455",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Tiện Ích",
                        "icon": "uni-icon uni-send",
                        "intPos": 5,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "TIEN_ICH",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "9001316F-D495-45C3-8091-DC1E22007B35",
                        "parentkey": null,
                        "id": "9001316f-d495-45c3-8091-dc1e22007b35",
                        "menuId": "f044f3c0-6cbd-4407-bbab-b630d1fa2455",
                        "parentId": "f044f3c0-6cbd-4407-bbab-b630d1fa2455",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Thêm mới",
                        "icon": "uni-icon uni-send",
                        "intPos": 6,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "THEM_MOI",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    }
                ],
                "key": "F044F3C0-6CBD-4407-BBAB-B630D1FA2455",
                "parentkey": null,
                "id": "f044f3c0-6cbd-4407-bbab-b630d1fa2455",
                "menuId": "f044f3c0-6cbd-4407-bbab-b630d1fa2455",
                "parentId": "c18fdc70-90df-47e2-b490-d949d8e65a0e",
                "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                "isNavHeader": null,
                "classs": "nav-item",
                "badge": null,
                "label": "Kho hàng",
                "icon": "pi pi-th-large",
                "intPos": 4,
                "childCount": 0,
                "isAction": false,
                "expanded": true,
                "actionCd": "",
                "actionType": "",
                "routerLink": "/danh-muc/kho-hang",
                "workCount": null
            },
            {
                "children": [
                    {
                        "children": [],
                        "key": "B6CC3D10-3AE0-40D1-957C-D295C44CB23B",
                        "parentkey": null,
                        "id": "b6cc3d10-3ae0-40d1-957c-d295c44cb23b",
                        "menuId": "8c01a8d7-d197-49f3-81e2-86c308ae1365",
                        "parentId": "8c01a8d7-d197-49f3-81e2-86c308ae1365",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Xóa",
                        "icon": "uni-icon uni-send",
                        "intPos": 1,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "XOA",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "4E8869D1-D7E4-4A59-9025-8DF4DE3A4568",
                        "parentkey": null,
                        "id": "4e8869d1-d7e4-4a59-9025-8df4de3a4568",
                        "menuId": "8c01a8d7-d197-49f3-81e2-86c308ae1365",
                        "parentId": "8c01a8d7-d197-49f3-81e2-86c308ae1365",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Sửa",
                        "icon": "uni-icon uni-send",
                        "intPos": 2,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "SUA",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "3CA92CF4-22AA-4BB3-A8BE-EB8A83420580",
                        "parentkey": null,
                        "id": "3ca92cf4-22aa-4bb3-a8be-eb8a83420580",
                        "menuId": "8c01a8d7-d197-49f3-81e2-86c308ae1365",
                        "parentId": "8c01a8d7-d197-49f3-81e2-86c308ae1365",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Tìm Kiếm",
                        "icon": "uni-icon uni-send",
                        "intPos": 3,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "TIM_KIEM",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "27543504-294F-402C-96A7-1A2022372BE7",
                        "parentkey": null,
                        "id": "27543504-294f-402c-96a7-1a2022372be7",
                        "menuId": "8c01a8d7-d197-49f3-81e2-86c308ae1365",
                        "parentId": "8c01a8d7-d197-49f3-81e2-86c308ae1365",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Tùy Chỉnh",
                        "icon": "uni-icon uni-send",
                        "intPos": 4,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "TUY_CHINH",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "480DEF2F-ECA7-4C4C-9A5B-1569CD9DD5FE",
                        "parentkey": null,
                        "id": "480def2f-eca7-4c4c-9a5b-1569cd9dd5fe",
                        "menuId": "8c01a8d7-d197-49f3-81e2-86c308ae1365",
                        "parentId": "8c01a8d7-d197-49f3-81e2-86c308ae1365",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Tiện Ích",
                        "icon": "uni-icon uni-send",
                        "intPos": 5,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "TIEN_ICH",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "AE20C773-C715-4BD0-85C9-E38CFB8F147A",
                        "parentkey": null,
                        "id": "ae20c773-c715-4bd0-85c9-e38cfb8f147a",
                        "menuId": "8c01a8d7-d197-49f3-81e2-86c308ae1365",
                        "parentId": "8c01a8d7-d197-49f3-81e2-86c308ae1365",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Thêm mới",
                        "icon": "uni-icon uni-send",
                        "intPos": 6,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "THEM_MOI",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    }
                ],
                "key": "8C01A8D7-D197-49F3-81E2-86C308AE1365",
                "parentkey": null,
                "id": "8c01a8d7-d197-49f3-81e2-86c308ae1365",
                "menuId": "8c01a8d7-d197-49f3-81e2-86c308ae1365",
                "parentId": "c18fdc70-90df-47e2-b490-d949d8e65a0e",
                "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                "isNavHeader": null,
                "classs": "nav-item",
                "badge": null,
                "label": "Đơn vị tính",
                "icon": "pi pi-percentage",
                "intPos": 5,
                "childCount": 0,
                "isAction": false,
                "expanded": true,
                "actionCd": "",
                "actionType": "",
                "routerLink": "/danh-muc/don-vi-tinh",
                "workCount": null
            },
            {
                "children": [],
                "key": "217D9999-EA0F-4B44-BC6F-1713CDDA99D5",
                "parentkey": null,
                "id": "217d9999-ea0f-4b44-bc6f-1713cdda99d5",
                "menuId": "217d9999-ea0f-4b44-bc6f-1713cdda99d5",
                "parentId": "c18fdc70-90df-47e2-b490-d949d8e65a0e",
                "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                "isNavHeader": null,
                "classs": null,
                "badge": null,
                "label": "Công ty nhận HĐ",
                "icon": "pi pi-file",
                "intPos": 6,
                "childCount": 0,
                "isAction": false,
                "expanded": true,
                "actionCd": "",
                "actionType": "",
                "routerLink": "danh-muc/cong-ty-nhan-hoa-don",
                "workCount": null
            }
        ],
        "key": "C18FDC70-90DF-47E2-B490-D949D8E65A0E",
        "parentkey": null,
        "id": "c18fdc70-90df-47e2-b490-d949d8e65a0e",
        "menuId": "c18fdc70-90df-47e2-b490-d949d8e65a0e",
        "parentId": null,
        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
        "isNavHeader": null,
        "classs": "navigation-header",
        "badge": null,
        "label": "Danh mục",
        "icon": "asset asset-danh-muc",
        "intPos": 2,
        "childCount": 5,
        "isAction": false,
        "expanded": true,
        "actionCd": "",
        "actionType": "",
        "routerLink": "danh-muc",
        "workCount": null
    },
    {
        "children": [
            {
                "children": [
                    {
                        "children": [],
                        "key": "6DA96B5F-3E76-4672-9487-AE9ABFF90BFC",
                        "parentkey": null,
                        "id": "6da96b5f-3e76-4672-9487-ae9abff90bfc",
                        "menuId": "3d2e3950-86c0-432a-857e-da6fe1ab7bac",
                        "parentId": "3d2e3950-86c0-432a-857e-da6fe1ab7bac",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Xem",
                        "icon": "uni-icon uni-send",
                        "intPos": 1,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "XEM",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "B51017E2-7B72-45D9-9280-7735E06FCB05",
                        "parentkey": null,
                        "id": "b51017e2-7b72-45d9-9280-7735e06fcb05",
                        "menuId": "3d2e3950-86c0-432a-857e-da6fe1ab7bac",
                        "parentId": "3d2e3950-86c0-432a-857e-da6fe1ab7bac",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Xóa nhiều",
                        "icon": "uni-icon uni-send",
                        "intPos": 2,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "XOA_NHIEU",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "0189BF09-59C2-4D68-B1DE-4017DC2F4B87",
                        "parentkey": null,
                        "id": "0189bf09-59c2-4d68-b1de-4017dc2f4b87",
                        "menuId": "3d2e3950-86c0-432a-857e-da6fe1ab7bac",
                        "parentId": "3d2e3950-86c0-432a-857e-da6fe1ab7bac",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "In phiếu",
                        "icon": "uni-icon uni-send",
                        "intPos": 3,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "IN_PHIEU",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "1E3C8D3D-7A24-4F44-8EAA-F71BC2D0601E",
                        "parentkey": null,
                        "id": "1e3c8d3d-7a24-4f44-8eaa-f71bc2d0601e",
                        "menuId": "3d2e3950-86c0-432a-857e-da6fe1ab7bac",
                        "parentId": "3d2e3950-86c0-432a-857e-da6fe1ab7bac",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Export",
                        "icon": "uni-icon uni-send",
                        "intPos": 4,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "EXPORT",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "6121A4C0-905A-4A6E-B5F2-25D5E4C08F77",
                        "parentkey": null,
                        "id": "6121a4c0-905a-4a6e-b5f2-25d5e4c08f77",
                        "menuId": "3d2e3950-86c0-432a-857e-da6fe1ab7bac",
                        "parentId": "3d2e3950-86c0-432a-857e-da6fe1ab7bac",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Import",
                        "icon": "uni-icon uni-send",
                        "intPos": 5,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "IMPORT",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "68B0E3BF-39AF-4701-AFD0-691B682F0243",
                        "parentkey": null,
                        "id": "68b0e3bf-39af-4701-afd0-691b682f0243",
                        "menuId": "3d2e3950-86c0-432a-857e-da6fe1ab7bac",
                        "parentId": "3d2e3950-86c0-432a-857e-da6fe1ab7bac",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Xóa",
                        "icon": "uni-icon uni-send",
                        "intPos": 6,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "XOA",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "1EA49E28-B48A-4EF3-8B79-88768144A1E8",
                        "parentkey": null,
                        "id": "1ea49e28-b48a-4ef3-8b79-88768144a1e8",
                        "menuId": "3d2e3950-86c0-432a-857e-da6fe1ab7bac",
                        "parentId": "3d2e3950-86c0-432a-857e-da6fe1ab7bac",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Sửa",
                        "icon": "uni-icon uni-send",
                        "intPos": 7,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "SUA",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "9FE9CDDA-9A83-4B95-B4ED-0D9CED34187D",
                        "parentkey": null,
                        "id": "9fe9cdda-9a83-4b95-b4ed-0d9ced34187d",
                        "menuId": "3d2e3950-86c0-432a-857e-da6fe1ab7bac",
                        "parentId": "3d2e3950-86c0-432a-857e-da6fe1ab7bac",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Tìm Kiếm",
                        "icon": "uni-icon uni-send",
                        "intPos": 8,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "TIM_KIEM",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "1B7955B9-2746-4D34-B5A3-852054ECE023",
                        "parentkey": null,
                        "id": "1b7955b9-2746-4d34-b5a3-852054ece023",
                        "menuId": "3d2e3950-86c0-432a-857e-da6fe1ab7bac",
                        "parentId": "3d2e3950-86c0-432a-857e-da6fe1ab7bac",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Tùy Chỉnh",
                        "icon": "uni-icon uni-send",
                        "intPos": 9,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "TUY_CHINH",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "DD09CDDE-BC5A-402C-9521-5B8463E67EA1",
                        "parentkey": null,
                        "id": "dd09cdde-bc5a-402c-9521-5b8463e67ea1",
                        "menuId": "3d2e3950-86c0-432a-857e-da6fe1ab7bac",
                        "parentId": "3d2e3950-86c0-432a-857e-da6fe1ab7bac",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Tiện Ích",
                        "icon": "uni-icon uni-send",
                        "intPos": 10,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "TIEN_ICH",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "01AA1E2C-3BBB-471A-A67C-162594067140",
                        "parentkey": null,
                        "id": "01aa1e2c-3bbb-471a-a67c-162594067140",
                        "menuId": "3d2e3950-86c0-432a-857e-da6fe1ab7bac",
                        "parentId": "3d2e3950-86c0-432a-857e-da6fe1ab7bac",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Thêm mới",
                        "icon": "uni-icon uni-send",
                        "intPos": 11,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "THEM_MOI",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    }
                ],
                "key": "3D2E3950-86C0-432A-857E-DA6FE1AB7BAC",
                "parentkey": null,
                "id": "3d2e3950-86c0-432a-857e-da6fe1ab7bac",
                "menuId": "3d2e3950-86c0-432a-857e-da6fe1ab7bac",
                "parentId": "5ea852a1-3460-4755-b941-feeddcc103a2",
                "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                "isNavHeader": null,
                "classs": "nav-item",
                "badge": null,
                "label": "Danh mục tài sản",
                "icon": null,
                "intPos": 1,
                "childCount": 0,
                "isAction": false,
                "expanded": true,
                "actionCd": "",
                "actionType": "",
                "routerLink": "/tai-san/tai-san",
                "workCount": null
            },
            {
                "children": [
                    {
                        "children": [],
                        "key": "00B610A8-1FB0-431F-87E6-4D831D12E006",
                        "parentkey": null,
                        "id": "00b610a8-1fb0-431f-87e6-4d831d12e006",
                        "menuId": "e3a73a99-be7e-49ac-bdea-7af7590adb08",
                        "parentId": "e3a73a99-be7e-49ac-bdea-7af7590adb08",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Xem",
                        "icon": "uni-icon uni-send",
                        "intPos": 1,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "XEM",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "11AB8B81-FF00-4777-9563-295D03835475",
                        "parentkey": null,
                        "id": "11ab8b81-ff00-4777-9563-295d03835475",
                        "menuId": "e3a73a99-be7e-49ac-bdea-7af7590adb08",
                        "parentId": "e3a73a99-be7e-49ac-bdea-7af7590adb08",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Tìm Kiếm",
                        "icon": "uni-icon uni-send",
                        "intPos": 2,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "TIM_KIEM",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "7F69751B-6DB6-4ABE-8A62-68716B904252",
                        "parentkey": null,
                        "id": "7f69751b-6db6-4abe-8a62-68716b904252",
                        "menuId": "e3a73a99-be7e-49ac-bdea-7af7590adb08",
                        "parentId": "e3a73a99-be7e-49ac-bdea-7af7590adb08",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Tùy Chỉnh",
                        "icon": "uni-icon uni-send",
                        "intPos": 3,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "TUY_CHINH",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "7FB876FF-2562-4D96-B7B0-DE01C9E2D0CD",
                        "parentkey": null,
                        "id": "7fb876ff-2562-4d96-b7b0-de01c9e2d0cd",
                        "menuId": "e3a73a99-be7e-49ac-bdea-7af7590adb08",
                        "parentId": "e3a73a99-be7e-49ac-bdea-7af7590adb08",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Tiện Ích",
                        "icon": "uni-icon uni-send",
                        "intPos": 4,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "TIEN_ICH",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "B7694370-4A98-44DF-B7B1-16A7877274D7",
                        "parentkey": null,
                        "id": "b7694370-4a98-44df-b7b1-16a7877274d7",
                        "menuId": "e3a73a99-be7e-49ac-bdea-7af7590adb08",
                        "parentId": "e3a73a99-be7e-49ac-bdea-7af7590adb08",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Thêm mới",
                        "icon": "uni-icon uni-send",
                        "intPos": 5,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "THEM_MOI",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    }
                ],
                "key": "E3A73A99-BE7E-49AC-BDEA-7AF7590ADB08",
                "parentkey": null,
                "id": "e3a73a99-be7e-49ac-bdea-7af7590adb08",
                "menuId": "e3a73a99-be7e-49ac-bdea-7af7590adb08",
                "parentId": "5ea852a1-3460-4755-b941-feeddcc103a2",
                "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                "isNavHeader": null,
                "classs": "nav-item",
                "badge": null,
                "label": "Công cụ",
                "icon": "pi pi-server",
                "intPos": 2,
                "childCount": 0,
                "isAction": false,
                "expanded": true,
                "actionCd": "",
                "actionType": "",
                "routerLink": "/tai-san/cong-cu",
                "workCount": null
            },
            {
                "children": [
                    {
                        "children": [],
                        "key": "95189BA9-BD9E-48E3-85D0-0A59A51F663C",
                        "parentkey": null,
                        "id": "95189ba9-bd9e-48e3-85d0-0a59a51f663c",
                        "menuId": "39de47e5-7d21-4569-8068-eea1da3bd859",
                        "parentId": "39de47e5-7d21-4569-8068-eea1da3bd859",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Xem",
                        "icon": "uni-icon uni-send",
                        "intPos": 1,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "XEM",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "BC5C37BB-59F2-4A19-AC0E-2BED4867AFC2",
                        "parentkey": null,
                        "id": "bc5c37bb-59f2-4a19-ac0e-2bed4867afc2",
                        "menuId": "39de47e5-7d21-4569-8068-eea1da3bd859",
                        "parentId": "39de47e5-7d21-4569-8068-eea1da3bd859",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Sửa",
                        "icon": "uni-icon uni-send",
                        "intPos": 1,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "SUA",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "386BB46A-174B-424D-8730-A0129E282DA1",
                        "parentkey": null,
                        "id": "386bb46a-174b-424d-8730-a0129e282da1",
                        "menuId": "39de47e5-7d21-4569-8068-eea1da3bd859",
                        "parentId": "39de47e5-7d21-4569-8068-eea1da3bd859",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Tìm Kiếm",
                        "icon": "uni-icon uni-send",
                        "intPos": 2,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "TIM_KIEM",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "336B7FB1-FBEC-473A-A050-A8B018ACB1EE",
                        "parentkey": null,
                        "id": "336b7fb1-fbec-473a-a050-a8b018acb1ee",
                        "menuId": "39de47e5-7d21-4569-8068-eea1da3bd859",
                        "parentId": "39de47e5-7d21-4569-8068-eea1da3bd859",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Thêm mới",
                        "icon": "uni-icon uni-send",
                        "intPos": 3,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "THEM_MOI",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    }
                ],
                "key": "39DE47E5-7D21-4569-8068-EEA1DA3BD859",
                "parentkey": null,
                "id": "39de47e5-7d21-4569-8068-eea1da3bd859",
                "menuId": "39de47e5-7d21-4569-8068-eea1da3bd859",
                "parentId": "5ea852a1-3460-4755-b941-feeddcc103a2",
                "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                "isNavHeader": null,
                "classs": "nav-item",
                "badge": null,
                "label": "Hoạt động",
                "icon": "pi pi-slack",
                "intPos": 3,
                "childCount": 0,
                "isAction": false,
                "expanded": true,
                "actionCd": "",
                "actionType": "",
                "routerLink": "/tai-san/danh-sach-hoat-dong",
                "workCount": null
            }
        ],
        "key": "5EA852A1-3460-4755-B941-FEEDDCC103A2",
        "parentkey": null,
        "id": "5ea852a1-3460-4755-b941-feeddcc103a2",
        "menuId": "5ea852a1-3460-4755-b941-feeddcc103a2",
        "parentId": null,
        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
        "isNavHeader": true,
        "classs": "navigation-header",
        "badge": null,
        "label": "Tài sản",
        "icon": "asset asset-tai-san",
        "intPos": 3,
        "childCount": 3,
        "isAction": false,
        "expanded": true,
        "actionCd": "",
        "actionType": "",
        "routerLink": "tai-san",
        "workCount": null
    },
    {
        "children": [
            {
                "children": [
                    {
                        "children": [],
                        "key": "3BA14E47-9A80-4A18-83C2-CD83BD022155",
                        "parentkey": null,
                        "id": "3ba14e47-9a80-4a18-83c2-cd83bd022155",
                        "menuId": "4d5abfc1-adcd-470d-af31-ee55d87fc2ac",
                        "parentId": "4d5abfc1-adcd-470d-af31-ee55d87fc2ac",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Xem",
                        "icon": "uni-icon uni-send",
                        "intPos": 1,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "XEM",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "C8B63ED8-E098-4966-B968-7820793B9B1F",
                        "parentkey": null,
                        "id": "c8b63ed8-e098-4966-b968-7820793b9b1f",
                        "menuId": "4d5abfc1-adcd-470d-af31-ee55d87fc2ac",
                        "parentId": "4d5abfc1-adcd-470d-af31-ee55d87fc2ac",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Xóa",
                        "icon": "uni-icon uni-send",
                        "intPos": 2,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "XOA",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "3829B172-28A4-4012-899C-5C364ADBFD8A",
                        "parentkey": null,
                        "id": "3829b172-28a4-4012-899c-5c364adbfd8a",
                        "menuId": "4d5abfc1-adcd-470d-af31-ee55d87fc2ac",
                        "parentId": "4d5abfc1-adcd-470d-af31-ee55d87fc2ac",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Sửa",
                        "icon": "uni-icon uni-send",
                        "intPos": 3,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "SUA",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "5510CCEB-779A-431B-89C7-485AA460A249",
                        "parentkey": null,
                        "id": "5510cceb-779a-431b-89c7-485aa460a249",
                        "menuId": "4d5abfc1-adcd-470d-af31-ee55d87fc2ac",
                        "parentId": "4d5abfc1-adcd-470d-af31-ee55d87fc2ac",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Tìm Kiếm Nâng Cao",
                        "icon": "uni-icon uni-send",
                        "intPos": 4,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "TIM_KIEM_NANG_CAO",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "47C4F03B-87E0-445A-828C-B8322F199156",
                        "parentkey": null,
                        "id": "47c4f03b-87e0-445a-828c-b8322f199156",
                        "menuId": "4d5abfc1-adcd-470d-af31-ee55d87fc2ac",
                        "parentId": "4d5abfc1-adcd-470d-af31-ee55d87fc2ac",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Tìm Kiếm",
                        "icon": "uni-icon uni-send",
                        "intPos": 5,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "TIM_KIEM",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "1EE96669-7B3A-44BC-90D6-D8608DF4C7A8",
                        "parentkey": null,
                        "id": "1ee96669-7b3a-44bc-90d6-d8608df4c7a8",
                        "menuId": "4d5abfc1-adcd-470d-af31-ee55d87fc2ac",
                        "parentId": "4d5abfc1-adcd-470d-af31-ee55d87fc2ac",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Thêm mới",
                        "icon": "uni-icon uni-send",
                        "intPos": 6,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "THEM_MOI",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    }
                ],
                "key": "4D5ABFC1-ADCD-470D-AF31-EE55D87FC2AC",
                "parentkey": null,
                "id": "4d5abfc1-adcd-470d-af31-ee55d87fc2ac",
                "menuId": "4d5abfc1-adcd-470d-af31-ee55d87fc2ac",
                "parentId": "340ef683-7701-4229-ba3a-0394280eb3e0",
                "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                "isNavHeader": null,
                "classs": "nav-item",
                "badge": null,
                "label": "Kiểm kê tài sản",
                "icon": null,
                "intPos": 1,
                "childCount": 0,
                "isAction": false,
                "expanded": true,
                "actionCd": "",
                "actionType": "",
                "routerLink": "/kiem-ke/kiem-ke-tai-san",
                "workCount": null
            }
        ],
        "key": "340EF683-7701-4229-BA3A-0394280EB3E0",
        "parentkey": null,
        "id": "340ef683-7701-4229-ba3a-0394280eb3e0",
        "menuId": "340ef683-7701-4229-ba3a-0394280eb3e0",
        "parentId": null,
        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
        "isNavHeader": true,
        "classs": "navigation-header",
        "badge": null,
        "label": "Kiểm kê tài sản",
        "icon": "asset asset-kiem-ke",
        "intPos": 4,
        "childCount": 1,
        "isAction": false,
        "expanded": true,
        "actionCd": "",
        "actionType": "",
        "routerLink": "kiem-ke",
        "workCount": null
    },
    {
        "children": [
            {
                "children": [
                    {
                        "children": [],
                        "key": "60D8214E-7B61-48B3-8845-B3474D4CAB0C",
                        "parentkey": null,
                        "id": "60d8214e-7b61-48b3-8845-b3474d4cab0c",
                        "menuId": "26247591-c048-4a33-a7f1-edd613d79e90",
                        "parentId": "26247591-c048-4a33-a7f1-edd613d79e90",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Export",
                        "icon": "uni-icon uni-send",
                        "intPos": 1,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "EXPORT",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "27E2E357-E74C-482B-B7E0-E5C390C636B5",
                        "parentkey": null,
                        "id": "27e2e357-e74c-482b-b7e0-e5c390c636b5",
                        "menuId": "26247591-c048-4a33-a7f1-edd613d79e90",
                        "parentId": "26247591-c048-4a33-a7f1-edd613d79e90",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Tìm Kiếm",
                        "icon": "uni-icon uni-send",
                        "intPos": 1,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "TIM_KIEM",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    }
                ],
                "key": "26247591-C048-4A33-A7F1-EDD613D79E90",
                "parentkey": null,
                "id": "26247591-c048-4a33-a7f1-edd613d79e90",
                "menuId": "26247591-c048-4a33-a7f1-edd613d79e90",
                "parentId": "f7fe1b67-1af6-4b53-8c18-2e757a56f124",
                "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                "isNavHeader": null,
                "classs": "nav-item a",
                "badge": null,
                "label": "Báo cáo trạng thái tài sản",
                "icon": null,
                "intPos": 1,
                "childCount": 0,
                "isAction": false,
                "expanded": true,
                "actionCd": "",
                "actionType": "",
                "routerLink": "/bao-cao/bao-cao-tong-hop-tai-san",
                "workCount": null
            },
            {
                "children": [
                    {
                        "children": [],
                        "key": "CD1FA3DF-D3CB-423E-9CDA-47EF5039125E",
                        "parentkey": null,
                        "id": "cd1fa3df-d3cb-423e-9cda-47ef5039125e",
                        "menuId": "f996663e-80dd-456b-9c6e-95fd113b6f6e",
                        "parentId": "f996663e-80dd-456b-9c6e-95fd113b6f6e",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Export",
                        "icon": "uni-icon uni-send",
                        "intPos": 1,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "EXPORT",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "9220D337-9004-40AA-A3BE-C12C9906D559",
                        "parentkey": null,
                        "id": "9220d337-9004-40aa-a3be-c12c9906d559",
                        "menuId": "f996663e-80dd-456b-9c6e-95fd113b6f6e",
                        "parentId": "f996663e-80dd-456b-9c6e-95fd113b6f6e",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Tùy Chỉnh",
                        "icon": "uni-icon uni-send",
                        "intPos": 2,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "TUY_CHINH",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    }
                ],
                "key": "F996663E-80DD-456B-9C6E-95FD113B6F6E",
                "parentkey": null,
                "id": "f996663e-80dd-456b-9c6e-95fd113b6f6e",
                "menuId": "f996663e-80dd-456b-9c6e-95fd113b6f6e",
                "parentId": "f7fe1b67-1af6-4b53-8c18-2e757a56f124",
                "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                "isNavHeader": null,
                "classs": "nav-item",
                "badge": null,
                "label": "Báo cáo chi tiết",
                "icon": "pi pi-chart-line",
                "intPos": 2,
                "childCount": 0,
                "isAction": false,
                "expanded": true,
                "actionCd": "",
                "actionType": "",
                "routerLink": "/bao-cao/bao-cao-chi-tiet",
                "workCount": null
            },
            {
                "children": [
                    {
                        "children": [],
                        "key": "F0CAB387-600E-4FB6-B569-9F2BA50DCDBE",
                        "parentkey": null,
                        "id": "f0cab387-600e-4fb6-b569-9f2ba50dcdbe",
                        "menuId": "90ee0329-9ac2-4556-af13-f6fd95c0e3da",
                        "parentId": "90ee0329-9ac2-4556-af13-f6fd95c0e3da",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Export",
                        "icon": "uni-icon uni-send",
                        "intPos": 1,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "EXPORT",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "D8397408-005A-4966-97E0-254C2784F9E2",
                        "parentkey": null,
                        "id": "d8397408-005a-4966-97e0-254c2784f9e2",
                        "menuId": "90ee0329-9ac2-4556-af13-f6fd95c0e3da",
                        "parentId": "90ee0329-9ac2-4556-af13-f6fd95c0e3da",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Tìm Kiếm Nâng Cao",
                        "icon": "uni-icon uni-send",
                        "intPos": 2,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "TIM_KIEM_NANG_CAO",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "9E679B7F-BFA0-4DB0-A858-274913456CCC",
                        "parentkey": null,
                        "id": "9e679b7f-bfa0-4db0-a858-274913456ccc",
                        "menuId": "90ee0329-9ac2-4556-af13-f6fd95c0e3da",
                        "parentId": "90ee0329-9ac2-4556-af13-f6fd95c0e3da",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Tìm Kiếm",
                        "icon": "uni-icon uni-send",
                        "intPos": 3,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "TIM_KIEM",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    }
                ],
                "key": "90EE0329-9AC2-4556-AF13-F6FD95C0E3DA",
                "parentkey": null,
                "id": "90ee0329-9ac2-4556-af13-f6fd95c0e3da",
                "menuId": "90ee0329-9ac2-4556-af13-f6fd95c0e3da",
                "parentId": "f7fe1b67-1af6-4b53-8c18-2e757a56f124",
                "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                "isNavHeader": null,
                "classs": "nav-item",
                "badge": null,
                "label": "Báo cáo xuất kho",
                "icon": "pi pi-table",
                "intPos": 3,
                "childCount": 0,
                "isAction": false,
                "expanded": true,
                "actionCd": "",
                "actionType": "",
                "routerLink": "/bao-cao/bao-cao-xuat-kho",
                "workCount": null
            },
            {
                "children": [
                    {
                        "children": [],
                        "key": "79E6B8D6-7261-40E7-BA0B-FB0CBA7F52DD",
                        "parentkey": null,
                        "id": "79e6b8d6-7261-40e7-ba0b-fb0cba7f52dd",
                        "menuId": "13368377-fb92-48f7-85f6-3e8d0cb1273f",
                        "parentId": "13368377-fb92-48f7-85f6-3e8d0cb1273f",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Export",
                        "icon": "uni-icon uni-send",
                        "intPos": 1,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "EXPORT",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "00AB8C15-D8C5-4DF0-9916-F2C1C4D71D64",
                        "parentkey": null,
                        "id": "00ab8c15-d8c5-4df0-9916-f2c1c4d71d64",
                        "menuId": "13368377-fb92-48f7-85f6-3e8d0cb1273f",
                        "parentId": "13368377-fb92-48f7-85f6-3e8d0cb1273f",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Tìm Kiếm Nâng Cao",
                        "icon": "uni-icon uni-send",
                        "intPos": 1,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "TIM_KIEM_NANG_CAO",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "6D77E789-2219-4362-AFC0-693E468404DB",
                        "parentkey": null,
                        "id": "6d77e789-2219-4362-afc0-693e468404db",
                        "menuId": "13368377-fb92-48f7-85f6-3e8d0cb1273f",
                        "parentId": "13368377-fb92-48f7-85f6-3e8d0cb1273f",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Tìm Kiếm",
                        "icon": "uni-icon uni-send",
                        "intPos": 2,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "TIM_KIEM",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    }
                ],
                "key": "13368377-FB92-48F7-85F6-3E8D0CB1273F",
                "parentkey": null,
                "id": "13368377-fb92-48f7-85f6-3e8d0cb1273f",
                "menuId": "13368377-fb92-48f7-85f6-3e8d0cb1273f",
                "parentId": "f7fe1b67-1af6-4b53-8c18-2e757a56f124",
                "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                "isNavHeader": null,
                "classs": "nav-item",
                "badge": null,
                "label": "Báo cáo mua sắm",
                "icon": "pi pi-shopping-cart",
                "intPos": 3,
                "childCount": 0,
                "isAction": false,
                "expanded": true,
                "actionCd": "",
                "actionType": "",
                "routerLink": "/bao-cao/bao-cao-mua-sam",
                "workCount": null
            },
            {
                "children": [
                    {
                        "children": [],
                        "key": "BD5A4870-7842-4D87-9064-D67F67A032C0",
                        "parentkey": null,
                        "id": "bd5a4870-7842-4d87-9064-d67f67a032c0",
                        "menuId": "84d92e88-612b-431c-9cad-8205b506a546",
                        "parentId": "84d92e88-612b-431c-9cad-8205b506a546",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Export",
                        "icon": "uni-icon uni-send",
                        "intPos": 1,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "EXPORT",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "FD6B6E87-59BE-4463-B943-7C2B85D31C78",
                        "parentkey": null,
                        "id": "fd6b6e87-59be-4463-b943-7c2b85d31c78",
                        "menuId": "84d92e88-612b-431c-9cad-8205b506a546",
                        "parentId": "84d92e88-612b-431c-9cad-8205b506a546",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Tìm Kiếm Nâng Cao",
                        "icon": "uni-icon uni-send",
                        "intPos": 2,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "TIM_KIEM_NANG_CAO",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "24F07D14-B634-4534-A973-0E2E4B0052C3",
                        "parentkey": null,
                        "id": "24f07d14-b634-4534-a973-0e2e4b0052c3",
                        "menuId": "84d92e88-612b-431c-9cad-8205b506a546",
                        "parentId": "84d92e88-612b-431c-9cad-8205b506a546",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Tìm Kiếm",
                        "icon": "uni-icon uni-send",
                        "intPos": 3,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "TIM_KIEM",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    }
                ],
                "key": "84D92E88-612B-431C-9CAD-8205B506A546",
                "parentkey": null,
                "id": "84d92e88-612b-431c-9cad-8205b506a546",
                "menuId": "84d92e88-612b-431c-9cad-8205b506a546",
                "parentId": "f7fe1b67-1af6-4b53-8c18-2e757a56f124",
                "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                "isNavHeader": null,
                "classs": "nav-item",
                "badge": null,
                "label": "Báo cáo tồn kho",
                "icon": "pi pi-cog",
                "intPos": 4,
                "childCount": 0,
                "isAction": false,
                "expanded": true,
                "actionCd": "",
                "actionType": "",
                "routerLink": "/bao-cao/bao-cao-ton-kho",
                "workCount": null
            },
            {
                "children": [
                    {
                        "children": [],
                        "key": "E247A187-DE2E-432D-9D75-189456C48B4A",
                        "parentkey": null,
                        "id": "e247a187-de2e-432d-9d75-189456c48b4a",
                        "menuId": "c5825181-4688-4c63-84c3-06f037d2859a",
                        "parentId": "c5825181-4688-4c63-84c3-06f037d2859a",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Export",
                        "icon": "uni-icon uni-send",
                        "intPos": 1,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "EXPORT",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [],
                        "key": "807D3385-B7E9-458B-9126-58243FE648B9",
                        "parentkey": null,
                        "id": "807d3385-b7e9-458b-9126-58243fe648b9",
                        "menuId": "c5825181-4688-4c63-84c3-06f037d2859a",
                        "parentId": "c5825181-4688-4c63-84c3-06f037d2859a",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Tìm Kiếm",
                        "icon": "uni-icon uni-send",
                        "intPos": 2,
                        "childCount": 0,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "TIM_KIEM",
                        "actionType": "action",
                        "routerLink": null,
                        "workCount": null
                    }
                ],
                "key": "C5825181-4688-4C63-84C3-06F037D2859A",
                "parentkey": null,
                "id": "c5825181-4688-4c63-84c3-06f037d2859a",
                "menuId": "c5825181-4688-4c63-84c3-06f037d2859a",
                "parentId": "f7fe1b67-1af6-4b53-8c18-2e757a56f124",
                "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                "isNavHeader": null,
                "classs": "nav-item",
                "badge": null,
                "label": "Báo cáo tình trạng",
                "icon": "pi pi-chart-pie",
                "intPos": 5,
                "childCount": 0,
                "isAction": false,
                "expanded": true,
                "actionCd": "",
                "actionType": "",
                "routerLink": "/bao-cao/bao-cao-tinh-trang",
                "workCount": null
            }
        ],
        "key": "F7FE1B67-1AF6-4B53-8C18-2E757A56F124",
        "parentkey": null,
        "id": "f7fe1b67-1af6-4b53-8c18-2e757a56f124",
        "menuId": "f7fe1b67-1af6-4b53-8c18-2e757a56f124",
        "parentId": null,
        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
        "isNavHeader": true,
        "classs": "navigation-header",
        "badge": null,
        "label": "Báo cáo",
        "icon": "pi pi-chart-line",
        "intPos": 6,
        "childCount": 6,
        "isAction": false,
        "expanded": true,
        "actionCd": "",
        "actionType": "",
        "routerLink": "bao-cao",
        "workCount": null
    },
    {
        "children": [
            {
                "children": [
                    {
                        "children": [
                            {
                                "children": [],
                                "key": "78C21935-1A91-4ED9-BEC5-B80037CF40C2",
                                "parentkey": null,
                                "id": "78c21935-1a91-4ed9-bec5-b80037cf40c2",
                                "menuId": "7e69ddcc-9909-48ad-a241-c129a900bcff",
                                "parentId": "7407d2e0-ef2a-4631-bd2f-1780c9de6c6b",
                                "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                                "isNavHeader": false,
                                "classs": "",
                                "badge": "",
                                "label": "Tìm Kiếm Nâng Cao",
                                "icon": "uni-icon uni-send",
                                "intPos": 1,
                                "childCount": 0,
                                "isAction": true,
                                "expanded": true,
                                "actionCd": "TIM_KIEM_NANG_CAO",
                                "actionType": "action",
                                "routerLink": null,
                                "workCount": null
                            },
                            {
                                "children": [],
                                "key": "1AF9438C-A311-492C-A2D2-EA0E30D66C34",
                                "parentkey": null,
                                "id": "1af9438c-a311-492c-a2d2-ea0e30d66c34",
                                "menuId": "7e69ddcc-9909-48ad-a241-c129a900bcff",
                                "parentId": "7407d2e0-ef2a-4631-bd2f-1780c9de6c6b",
                                "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                                "isNavHeader": false,
                                "classs": "",
                                "badge": "",
                                "label": "Export",
                                "icon": "uni-icon uni-send",
                                "intPos": 1,
                                "childCount": 0,
                                "isAction": true,
                                "expanded": true,
                                "actionCd": "EXPORT",
                                "actionType": "action",
                                "routerLink": null,
                                "workCount": null
                            },
                            {
                                "children": [],
                                "key": "4129491C-20B0-45B2-B20A-31252421D2DB",
                                "parentkey": null,
                                "id": "4129491c-20b0-45b2-b20a-31252421d2db",
                                "menuId": "7e69ddcc-9909-48ad-a241-c129a900bcff",
                                "parentId": "7407d2e0-ef2a-4631-bd2f-1780c9de6c6b",
                                "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                                "isNavHeader": false,
                                "classs": "",
                                "badge": "",
                                "label": "Tìm Kiếm",
                                "icon": "uni-icon uni-send",
                                "intPos": 1,
                                "childCount": 0,
                                "isAction": true,
                                "expanded": true,
                                "actionCd": "TIM_KIEM",
                                "actionType": "action",
                                "routerLink": null,
                                "workCount": null
                            }
                        ],
                        "key": "7407D2E0-EF2A-4631-BD2F-1780C9DE6C6B",
                        "parentkey": null,
                        "id": "7407d2e0-ef2a-4631-bd2f-1780c9de6c6b",
                        "menuId": "7e69ddcc-9909-48ad-a241-c129a900bcff",
                        "parentId": "7e69ddcc-9909-48ad-a241-c129a900bcff",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Tab lịch sự công cụ",
                        "icon": "uni-icon uni-send",
                        "intPos": 1,
                        "childCount": 3,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "TAB_LICH_SU_CONG_CU",
                        "actionType": "tab",
                        "routerLink": null,
                        "workCount": null
                    },
                    {
                        "children": [
                            {
                                "children": [],
                                "key": "64CD9FDC-38C1-42C8-8CC1-1E31CCD2038B",
                                "parentkey": null,
                                "id": "64cd9fdc-38c1-42c8-8cc1-1e31ccd2038b",
                                "menuId": "7e69ddcc-9909-48ad-a241-c129a900bcff",
                                "parentId": "3045471a-d6a0-4048-b662-8cbc3e0966c1",
                                "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                                "isNavHeader": false,
                                "classs": "",
                                "badge": "",
                                "label": "Tìm Kiếm",
                                "icon": "uni-icon uni-send",
                                "intPos": 1,
                                "childCount": 0,
                                "isAction": true,
                                "expanded": true,
                                "actionCd": "TIM_KIEM",
                                "actionType": "action",
                                "routerLink": null,
                                "workCount": null
                            },
                            {
                                "children": [],
                                "key": "AE397645-491B-417E-9156-2F09A61B8DC9",
                                "parentkey": null,
                                "id": "ae397645-491b-417e-9156-2f09a61b8dc9",
                                "menuId": "7e69ddcc-9909-48ad-a241-c129a900bcff",
                                "parentId": "3045471a-d6a0-4048-b662-8cbc3e0966c1",
                                "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                                "isNavHeader": false,
                                "classs": "",
                                "badge": "",
                                "label": "Export",
                                "icon": "uni-icon uni-send",
                                "intPos": 1,
                                "childCount": 0,
                                "isAction": true,
                                "expanded": true,
                                "actionCd": "EXPORT",
                                "actionType": "action",
                                "routerLink": null,
                                "workCount": null
                            },
                            {
                                "children": [],
                                "key": "8B4CF72E-EED8-4837-B599-C164145C9154",
                                "parentkey": null,
                                "id": "8b4cf72e-eed8-4837-b599-c164145c9154",
                                "menuId": "7e69ddcc-9909-48ad-a241-c129a900bcff",
                                "parentId": "3045471a-d6a0-4048-b662-8cbc3e0966c1",
                                "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                                "isNavHeader": false,
                                "classs": "",
                                "badge": "",
                                "label": "Tìm Kiếm Nâng Cao",
                                "icon": "uni-icon uni-send",
                                "intPos": 2,
                                "childCount": 0,
                                "isAction": true,
                                "expanded": true,
                                "actionCd": "TIM_KIEM_NANG_CAO",
                                "actionType": "action",
                                "routerLink": null,
                                "workCount": null
                            }
                        ],
                        "key": "3045471A-D6A0-4048-B662-8CBC3E0966C1",
                        "parentkey": null,
                        "id": "3045471a-d6a0-4048-b662-8cbc3e0966c1",
                        "menuId": "7e69ddcc-9909-48ad-a241-c129a900bcff",
                        "parentId": "7e69ddcc-9909-48ad-a241-c129a900bcff",
                        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                        "isNavHeader": false,
                        "classs": "",
                        "badge": "",
                        "label": "Tab lịch sự hoạt động",
                        "icon": "uni-icon uni-send",
                        "intPos": 2,
                        "childCount": 3,
                        "isAction": true,
                        "expanded": true,
                        "actionCd": "TAB_LICH_SU_HOAT_DONG",
                        "actionType": "tab",
                        "routerLink": null,
                        "workCount": null
                    }
                ],
                "key": "7E69DDCC-9909-48AD-A241-C129A900BCFF",
                "parentkey": null,
                "id": "7e69ddcc-9909-48ad-a241-c129a900bcff",
                "menuId": "7e69ddcc-9909-48ad-a241-c129a900bcff",
                "parentId": "99e38053-6ecd-41b0-b330-c8cde319a207",
                "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
                "isNavHeader": null,
                "classs": "nav-item",
                "badge": null,
                "label": "Truy vết lịch sử",
                "icon": "pi pi-history",
                "intPos": 7,
                "childCount": 0,
                "isAction": false,
                "expanded": true,
                "actionCd": "",
                "actionType": "",
                "routerLink": "/quan-ly/truy-vet-lich-su",
                "workCount": null
            }
        ],
        "key": "99E38053-6ECD-41B0-B330-C8CDE319A207",
        "parentkey": null,
        "id": "99e38053-6ecd-41b0-b330-c8cde319a207",
        "menuId": "99e38053-6ecd-41b0-b330-c8cde319a207",
        "parentId": null,
        "webId": "7af9293e-0a78-4b53-ae0e-288abbf7e844",
        "isNavHeader": true,
        "classs": "navigation-header",
        "badge": null,
        "label": "Quản lý",
        "icon": "asset asset-quan-ly",
        "intPos": 7,
        "childCount": 1,
        "isAction": false,
        "expanded": true,
        "actionCd": "",
        "actionType": "",
        "routerLink": "quan-ly",
        "workCount": null
    }
]